import { getSummaryValue, makeExpEstRow, makeExpEstHeaders, getTitle, makeModelTable } from '../utils'
import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'
import { pick } from 'lodash-es'

const modelSummaryMapper = (item, meta) => {
  const selectedValue = getSummaryValue(item?.selectedValue ?? item?.predicted, getTitle(meta))

  return {
    values: [selectedValue],
    tables: [
      {
        headers: makeExpEstHeaders(),
        rows: [makeExpEstRow(item?.experimental, item?.predicted, getTitle(meta))],
      },
    ],
  }
}

const modelDescriptorsMapper = (itemWsKow) => ({
  tables: [makeModelTable(pick(itemWsKow?.predicted?.model, ['waterSolubility', 'factors']))],
})

const wsKow = (items) => {
  const item = items?.find((item) => item?.property === 'waterSolubilityFromLogKow')
  const meta = findEpiSuiteGroupById('waterSolubilityFromLogKow')

  return {
    title: getTitle(meta),
    description: meta?.description,
    helpPage: meta?.helpPage,
    summary: modelSummaryMapper(item, meta),
    modelDescriptors: modelDescriptorsMapper(item),
    modelOutput: item?.predicted?.model?.output,
  }
}

export { wsKow }
